const en = {
  searchPlaceholder: 'Search by your keywords',
  allQuestionsButtonLabel: 'All Questions',
  showMoreText: 'Show more',
  showLessText: 'Show less',
  noResultsText: ' No results found',
  labelText: 'Product stage',
};

export default en;
